import moment from "moment";

import { Badge, CurrencyDisplay } from "../../components";
import { appConfig } from "../../configs";
import {
  IViewInterProcessorSingleTransfer,
  StatusColors,
} from "../../interfaces-and-types";
import { getInterProcessorSingleTransferStatusIndicator } from "../../utils";

export const interProcessorBalanceTransfersDisplayFormatter = (
  item: IViewInterProcessorSingleTransfer,
) => {
  const statusIndicator: { statusText: string; statusType: StatusColors } =
    getInterProcessorSingleTransferStatusIndicator(item);

  return {
    ...item,
    amount: (
      <CurrencyDisplay
        currencyOrSymbol={item.currency}
        amount={item.amount}
        title={item.description}
      />
    ),
    gateway_fee: (
      <CurrencyDisplay
        currencyOrSymbol={item.currency}
        amount={item.gateway_fee}
        title={item.description}
      />
    ),
    status: (
      <Badge
        text={statusIndicator.statusText}
        statusColor={statusIndicator.statusType}
      />
    ),
    description: <strong>{item.description || "..."}</strong>,
    gateway: (
      <img
        src={`${appConfig.merchantDashboardBaseUrl}/gateway-logos/${item.gateway_code}-icon.svg`}
        // src={`${process.env.PUBLIC_URL}/gateway-logos/${item.gateway_code}.svg`}
        alt="gateway logo"
        className="gateway-logo-full"
        title={item.gateway_code}
      />
    ),
    destination_gateway: (
      <img
        src={`${appConfig.merchantDashboardBaseUrl}/gateway-logos/${item.destination_gateway_code}-icon.svg`}
        // src={`${process.env.PUBLIC_URL}/gateway-logos/${item.gateway_code}.svg`}
        alt="gateway logo"
        className="gateway-logo-full"
        title={item.destination_gateway_code}
      />
    ),
    destination_bank: (
      <span title={item.description}>
        {item.bank_name} |{" "}
        <strong>
          {item.account_number} ({item.account_name})
        </strong>
      </span>
    ),
    created: (
      <span className="date--oneline">
        {moment(item.created_at).format(appConfig.dateTimeFormat)}
      </span>
    ),
    completedOn: (
      <span className="date--oneline">
        {moment(item.paid_at).format(appConfig.dateTimeFormat)}
      </span>
    ),
    // more: <OverflowMenuDropDown />,
  };
};
